
<style>
    .form-material select, .form-material input, .form-material textarea, languageSelector select {
      width: 100%;
      font-size:14px;
    }

  .form-material select {
    font-size:14px;
    font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }

  .languageContainer {
    display:block;
    margin-bottom:10px;
  }

  .globalContainer {
    display:block;
    margin-bottom:10px;
    padding:12px;
  }

  textarea {min-height: 100px;}

  </style>

  <app-modal-header [headerTitle]="'Edit Lectionary Item Name'" (languageSelected)="setSelectedLanguage($event)"></app-modal-header>

 
  <div *ngIf="listsLoaded == true && item != null">

    <div mat-dialog-content>
 
      <div *ngIf="CurrentLocalizedData() != null" style="border-bottom:1px solid gray">
          {{currentLanguage.Name}}
      </div>

      <div *ngIf="CurrentLocalizedData() != null" class="languageContainer">

          <div class="form-group row">

              <div class="col-12">
                  <div class="form-material">
                      <input matInput [(ngModel)]="CurrentLocalizedData().Name">

                      <div *ngIf="isValidName == false">
                        <span [matTooltip]="'This name is not valid according to LAPI validation'" class="fa fa-warning fa-2"></span> 
                        {{validationError}}
                      </div>
                      <label for="">Name</label>
                  </div>
              </div>

          </div>

      </div>

      <div  style="border-bottom:1px solid gray">All Languages</div>

      <div class="form-group row">

          <div class="col-6">
              <div class="form-material">

                  <select [ngModel]="item.LectionaryItemType?.Id"  (ngModelChange)="item.LectionaryItemType = setModelValueOfCollection($event, item.LectionaryItemType, lectionaryItemTypes)">
                      <option *ngFor="let section of lectionaryItemTypes" [ngValue]="section.Id">
                          {{section.Localized[0].Name}}
                      </option>
                    </select>

                  <label for="">Lectionary Item Type</label>
 

              </div>
          </div>

          <div class="col-6">
              <div class="form-material">

                  <select [ngModel]="item.ReligionBranch?.Id"  (ngModelChange)="item.ReligionBranch = setModelValue($event, item.ReligionBranch)">
                      <option *ngFor="let section of religionBranches" [ngValue]="section.Id">
                          {{section.Name}}
                      </option>
                    </select>

                  <label for="">Religion Branch</label>

              </div>
          </div>
 
      </div>

      <div class="row">
      
        <div class="col-sm-12">
          
          <div mat-dialog-actions class="float-right">
              <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
              <button mat-button (click)="save()"   class="btn btn-sm btn-outline-primary">Save</button>
          </div>
          
        </div>
  
      </div>

 
    <div class="row" style="padding-bottom: 20px;" *ngIf="item?.Id != null"> 

      <div class="col-sm-12" style="padding-bottom: 10px;"> 
        <app-lectionary-item-name-edit-show-mappings [lectionaryItemNameId]="item.Id" ></app-lectionary-item-name-edit-show-mappings> 
      </div>

      <div class="col-sm-12"> 
        <app-lectionary-item-name-edit-show-items [lectionaryItemNameId]="item.Id" ></app-lectionary-item-name-edit-show-items> 
      </div>

    </div>


  </div>




</div>
